import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getAuth, onAuthStateChanged } from 'firebase/auth';

const TerminalPage = () => {
  const navigate = useNavigate();
  const auth = getAuth();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        // User is authenticated, navigate to Dashboard
        navigate("/DashBoard");
      } else {
        // No user is signed in, navigate to SignInTerminal
        navigate("/SignInTerminal");
      }
      setLoading(false);
    });

    // Cleanup the listener on unmount
    return () => unsubscribe();
  }, [auth, navigate]);

  if (loading) return <div>Loading...</div>;

  // TerminalPage doesn't need to render anything if navigation occurs immediately
  return null;
};

export default TerminalPage;
